/* Created by Interactive 63 - https://interactive63.com */
/**
 * Editor actions for the artboard: the frame around the artwork, and the colour behind it. The
 * artwork itself never moves, so changing the frame never touches an element or a keyframe.
 */
import type { Box } from '../../core/model/artboard';
import type { Store } from './store';

/** Sets the artboard frame. Pass a coalesce key while dragging so it is one undo step. */
export function setArtboard(store: Store, box: Box, coalesceKey?: string): void {
  store.updateProject(
    'Change artboard',
    (draft) => {
      draft.svg.viewBox = { x: box.x, y: box.y, width: box.width, height: box.height };
    },
    { coalesceKey },
  );
}

/** Sets the colour behind the artwork, or clears it for a transparent artboard. */
export function setArtboardBackground(
  store: Store,
  colour: string | null,
  coalesceKey?: string,
): void {
  store.updateProject(
    'Change artboard background',
    (draft) => {
      if (colour === null) delete draft.svg.background;
      else draft.svg.background = colour;
    },
    { coalesceKey },
  );
}
